import ShelfController from '../../core/shelf.controller';

class AuditorFieldOptionsController extends ShelfController {
    state = {
        loading: true,
        saving: false,
        categories: [],       // [{name: string, segments: string[]}]
        categoryInput: '',
        selectedCategory: null, // name of the currently expanded category
        segmentInput: ''
    };

    async initialize() {
        if (!this.isAuthenticated) {
            this.navigateLogin();
            return;
        }
        await this.loadOptions();
        this.setState({ loading: false });
    }

    async loadOptions() {
        try {
            const res = await this.data.fetchAuditFieldOptions();
            if (res?.success) {
                const raw = Array.isArray(res.categories) ? res.categories : [];
                const categories = raw
                    .map((c) => {
                        if (c && typeof c === 'object' && typeof c.name === 'string') return c;
                        if (typeof c === 'string' && c.trim()) return { name: c.trim(), segments: [] };
                        return null;
                    })
                    .filter(Boolean);
                this.setState({ categories });
            }
        } catch (e) {
            this.props.onMessage?.('error', e?.message || 'No se pudieron cargar las opciones');
        }
    }

    // The category whose segments are being edited (or null).
    get activeCategory() {
        const { categories, selectedCategory } = this.state;
        return categories.find((c) => c.name === selectedCategory) || null;
    }

    setCategoryInput = (categoryInput) => this.setState({ categoryInput });
    setSegmentInput = (segmentInput) => this.setState({ segmentInput });

    selectCategory = (name) => {
        this.setState((prev) => ({
            selectedCategory: prev.selectedCategory === name ? null : name,
            segmentInput: ''
        }));
    };

    addCategory = () => {
        const { categoryInput, categories } = this.state;
        const v = String(categoryInput || '').trim();
        if (!v) return;
        if (categories.some((c) => c?.name?.toLowerCase() === v.toLowerCase())) {
            this.props.onMessage?.('warning', 'Esa categoría ya existe');
            return;
        }
        this.setState({
            categories: [...categories, { name: v, segments: [] }],
            categoryInput: '',
            selectedCategory: v
        });
    };

    removeCategory = (name) => {
        this.setState((prev) => ({
            categories: prev.categories.filter((c) => c.name !== name),
            selectedCategory: prev.selectedCategory === name ? null : prev.selectedCategory,
            segmentInput: ''
        }));
    };

    addSegment = () => {
        const { segmentInput, categories, selectedCategory } = this.state;
        if (!selectedCategory) return;
        const v = String(segmentInput || '').trim();
        if (!v) return;
        const updatedCategories = categories.map((c) => {
            if (c.name !== selectedCategory) return c;
            if (c.segments.some((s) => s.toLowerCase() === v.toLowerCase())) {
                this.props.onMessage?.('warning', 'Ese segmento ya existe en esta categoría');
                return c;
            }
            return { ...c, segments: [...c.segments, v] };
        });
        this.setState({ categories: updatedCategories, segmentInput: '' });
    };

    removeSegment = (categoryName, segment) => {
        const updatedCategories = this.state.categories.map((c) => {
            if (c.name !== categoryName) return c;
            return { ...c, segments: c.segments.filter((s) => s !== segment) };
        });
        this.setState({ categories: updatedCategories });
    };

    saveOptions = async () => {
        const { categories } = this.state;
        this.setState({ saving: true });
        try {
            const res = await this.data.updateAuditFieldOptions({ categories });
            if (res?.success) {
                this.props.onMessage?.('success', 'Opciones guardadas. La app de auditoría las sincronizará al abrir una auditoría.');
                this.setState({
                    categories: Array.isArray(res.categories) ? res.categories : [],
                    saving: false
                });
            } else {
                this.props.onMessage?.('error', res?.message || 'No se pudo guardar');
                this.setState({ saving: false });
            }
        } catch (e) {
            this.props.onMessage?.('error', e?.message || 'Error de red');
            this.setState({ saving: false });
        }
    };
}

export default AuditorFieldOptionsController;
